import { registerAllFields } from './registry/builtInFields.js'
import FormComponentsPlugin from './components/index.js'

let installed = false

export function setupForm(app) {
	if (installed) {
	    console.warn('[VuForm] setupForm already called')
	    return
	}
	installed = true
	  
	registerAllFields()
	
	app.use(FormComponentsPlugin)
}